module.exports = __webpack_public_path__ + "assets/1809cbf0d03ccbc9d697ba135d23343e.png";